// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

function OrderSummary({
    discountTotal,
    discountTax,
    shipping,
    shippingTax,
    cartTax,
    total,
    totalTax,
    pricesIncludeTax,
    payment_method,
    payment_method_title,
    shipping_lines,
}) {
    return (
        <MDBox
            sx={{
                background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                border: '1px solid #e2e8f0',
                borderRadius: '16px',
                padding: '24px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.3s ease',
                position: 'relative',
                overflow: 'hidden',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                '&:hover': {
                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                    transform: 'translateY(-2px)',
                },
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'linear-gradient(90deg, #10B981, #059669)',
                    borderRadius: '16px 16px 0 0',
                },
            }}
        >
            <MDBox mb={3} display="flex" alignItems="center">
                <MDBox
                    sx={{
                        width: '24px',
                        height: '24px',
                        backgroundColor: '#10B981',
                        borderRadius: '6px',
                        marginRight: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <MDTypography sx={{ color: 'white', fontSize: '14px', fontWeight: 'bold' }}>💰</MDTypography>
                </MDBox>
                <MDTypography variant="h6" fontWeight="bold" sx={{ color: '#1f2937', fontSize: '1.2rem' }}>
                    Sipariş Özeti
                </MDTypography>
            </MDBox>

            {/* Fiyat Detayları */}
            <MDBox sx={{ flex: 1 }}>
                {/* Ara Toplam */}
                <MDBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                    sx={{
                        backgroundColor: '#f9fafb',
                        borderRadius: '8px',
                        padding: '12px 16px',
                        border: '1px solid #e5e7eb',
                    }}
                >
                    <MDTypography variant="button" fontWeight="medium" sx={{ color: '#6B7280', fontSize: '0.875rem' }}>
                        Ara Toplam:
                    </MDTypography>
                    <MDTypography variant="body2" fontWeight="bold" sx={{ color: '#374151', fontSize: '0.875rem' }}>
                        ₺{(total - totalTax - shipping - shippingTax + Number(discountTotal)).toFixed(2)}
                    </MDTypography>
                </MDBox>

                {/* İndirim */}
                {Number(discountTotal) > 0 && (
                    <MDBox
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={2}
                        sx={{
                            backgroundColor: '#fef2f2',
                            borderRadius: '8px',
                            padding: '12px 16px',
                            border: '1px solid #f87171',
                        }}
                    >
                        <MDTypography
                            variant="button"
                            fontWeight="medium"
                            sx={{ color: '#6B7280', fontSize: '0.875rem' }}
                        >
                            💸 İndirim:
                        </MDTypography>
                        <MDTypography variant="body2" fontWeight="bold" sx={{ color: '#dc2626', fontSize: '0.875rem' }}>
                            -₺{Number(discountTotal).toFixed(2)}
                        </MDTypography>
                    </MDBox>
                )}

                {/* Kargo */}
                <MDBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={3}
                    sx={{
                        backgroundColor: '#eff6ff',
                        borderRadius: '8px',
                        padding: '12px 16px',
                        border: '1px solid #bfdbfe',
                    }}
                >
                    <MDTypography variant="button" fontWeight="medium" sx={{ color: '#6B7280', fontSize: '0.875rem' }}>
                        🚚 Kargo: {shipping_lines ? shipping_lines[0]?.method_title : ''}
                    </MDTypography>
                    <MDTypography variant="body2" fontWeight="bold" sx={{ color: '#374151', fontSize: '0.875rem' }}>
                        ₺{Number(shipping).toFixed(2)}
                    </MDTypography>
                </MDBox>

                {/* Toplam */}
                <MDBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                        background: 'linear-gradient(135deg, #10B981, #059669)',
                        borderRadius: '12px',
                        padding: '16px 20px',
                        marginBottom: '16px',
                    }}
                >
                    <MDTypography variant="h6" fontWeight="bold" sx={{ color: '#ffffff', fontSize: '1.1rem' }}>
                        TOPLAM:
                    </MDTypography>
                    <MDTypography variant="h5" fontWeight="bold" sx={{ color: '#ffffff', fontSize: '1.4rem' }}>
                        ₺{Number(total).toFixed(2)}
                    </MDTypography>
                </MDBox>
            </MDBox>

            {/* Ödeme Bilgisi - En altta */}
            <MDBox
                sx={{
                    backgroundColor: payment_method !== 'iyzico' ? '#fef3c7' : '#f0fdf4',
                    border: payment_method !== 'iyzico' ? '1px solid #fbbf24' : '1px solid #bbf7d0',
                    borderRadius: '10px',
                    padding: '16px',
                    marginTop: 'auto',
                }}
            >
                <MDBox display="flex" alignItems="center" mb={1}>
                    <MDTypography sx={{ fontSize: '16px', marginRight: '8px' }}>
                        {payment_method !== 'iyzico' ? '⚠️' : '✅'}
                    </MDTypography>
                    <MDTypography variant="caption" fontWeight="bold" sx={{ color: '#374151', fontSize: '0.8rem' }}>
                        Ödeme Yöntemi
                    </MDTypography>
                </MDBox>
                <MDTypography variant="body2" fontWeight="medium" sx={{ color: '#374151' }}>
                    {payment_method_title} | {payment_method}
                </MDTypography>
                {payment_method !== 'iyzico' && (
                    <MDTypography
                        variant="caption"
                        fontWeight="bold"
                        display="block"
                        sx={{ color: '#d97706', marginTop: '8px', fontSize: '0.75rem' }}
                    >
                        🔔 Ödeme yöntemine dikkat edin!
                    </MDTypography>
                )}
            </MDBox>
        </MDBox>
    );
}

export default OrderSummary;
